import { defineComponent as L, ref as N, computed as y, toRef as R, resolveComponent as v, openBlock as d, createElementBlock as P, createBlock as $, withCtx as s, createElementVNode as p, mergeProps as c, normalizeClass as r, toDisplayString as a, createVNode as i, createTextVNode as n, renderSlot as f, normalizeProps as C, guardReactiveProps as w, createCommentVNode as g } from "vue";
import { usePopoverState as V, useResponsive as j } from "@onereach/ui-components-common/hooks";
import { O as z } from "./OrButton-C_hXddAf.mjs";
import { O as A } from "./OrModal-CQhwUYFk.mjs";
import { O as E, a as U } from "./OrPopover-DbygLPtT.mjs";
import "@onereach/ui-components-common/utils";
import { _ as H } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const T = [
  // Layout
  "layout-column",
  // Box
  "w-auto md:w-[352px]",
  // Spacing
  "px-0 md:px-md",
  "py-0 md:py-md",
  "gap-md"
], q = [
  // Layout
  "layout-row",
  // Spacing
  "gap-md",
  // Typography
  "typography-headline-3"
], G = [
  // Layout
  "layout-row-reverse",
  // Spacing
  "gap-md"
], I = L({
  name: "OrFilterPopover",
  components: {
    OrButton: z,
    OrModal: A,
    OrPopover: E
  },
  inheritAttrs: !1,
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "Filters"
    },
    applyLabel: {
      type: String,
      default: "View Results"
    },
    resetLabel: {
      type: String,
      default: "Reset All"
    },
    closeLabel: {
      type: String,
      default: "Close"
    },
    trigger: {
      type: Object,
      default: void 0
    },
    placement: {
      type: String,
      default: () => U.BottomStart
    },
    fallbackPlacement: {
      type: String,
      default: void 0
    },
    enableDesktopControls: {
      type: Boolean,
      default: !1
    },
    offset: {
      type: [Number, Object, Function],
      default: 8
    }
  },
  emits: [
    "update:state",
    "open",
    "close",
    "apply",
    "reset"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, o) {
    const k = N(), b = y(() => [
      "or-filter-popover-v3",
      ...T
    ]), O = y(() => [
      ...q
    ]), S = y(() => [
      ...G
    ]), { state: l, open: m, close: u, toggle: t } = V(R(e, "isOpen"), o.emit);
    function B() {
      o.emit("apply");
    }
    function D() {
      o.emit("reset");
    }
    const { isDesktop: M, isMobile: F } = j();
    return {
      root: k,
      rootStyles: b,
      headerStyles: O,
      footerStyles: S,
      state: l,
      open: m,
      close: u,
      toggle: t,
      apply: B,
      reset: D,
      isDesktop: M,
      isMobile: F
    };
  }
}), J = {
  class: /* @__PURE__ */ r(["contents"])
}, K = {
  class: /* @__PURE__ */ r(["grow", "truncate"])
};
function Q(e, o, k, b, O, S) {
  const l = v("OrButton"), m = v("OrPopover"), u = v("OrModal");
  return d(), P("div", J, [
    e.isDesktop ? (d(), $(m, {
      key: 0,
      "is-open": e.state === "open",
      variant: "popover",
      trigger: e.trigger,
      placement: e.placement,
      "fallback-placement": e.fallbackPlacement,
      offset: e.offset,
      "onUpdate:state": o[3] || (o[3] = (t) => t === "open" ? e.open() : e.close())
    }, {
      default: s(() => [
        p("div", c(e.$attrs, {
          ref: "root",
          class: e.rootStyles
        }), [
          p("div", {
            class: r(e.headerStyles)
          }, [
            p("div", K, a(e.title), 1),
            i(l, {
              variant: "link",
              onClick: o[0] || (o[0] = (t) => e.reset())
            }, {
              default: s(() => [
                n(a(e.resetLabel), 1)
              ]),
              _: 1
            })
          ], 2),
          f(e.$slots, "default"),
          f(e.$slots, "actions", C(w({ apply: e.apply, reset: e.reset, isDesktop: e.isDesktop, isMobile: e.isMobile })), () => [
            e.enableDesktopControls ? (d(), P("div", {
              key: 0,
              class: r(e.footerStyles)
            }, [
              i(l, {
                class: r(["grow"]),
                variant: "contained",
                onClick: o[1] || (o[1] = (t) => e.apply())
              }, {
                default: s(() => [
                  n(a(e.applyLabel), 1)
                ]),
                _: 1
              }),
              i(l, {
                class: r(["grow"]),
                variant: "outlined",
                onClick: o[2] || (o[2] = (t) => e.close())
              }, {
                default: s(() => [
                  n(a(e.closeLabel), 1)
                ]),
                _: 1
              })
            ], 2)) : g("", !0)
          ])
        ], 16)
      ]),
      _: 3
    }, 8, ["is-open", "trigger", "placement", "fallback-placement", "offset"])) : g("", !0),
    e.isMobile ? (d(), $(u, {
      key: 1,
      "is-open": e.state === "open",
      "onUpdate:state": o[6] || (o[6] = (t) => t === "open" ? e.open() : e.close())
    }, {
      header: s(() => [
        n(a(e.title), 1)
      ]),
      footer: s(() => [
        f(e.$slots, "actions", C(w({ apply: e.apply, reset: e.reset, isDesktop: e.isDesktop, isMobile: e.isMobile })), () => [
          p("div", {
            class: r(e.footerStyles)
          }, [
            i(l, {
              class: r(["grow"]),
              variant: "contained",
              onClick: o[4] || (o[4] = (t) => e.apply())
            }, {
              default: s(() => [
                n(a(e.applyLabel), 1)
              ]),
              _: 1
            }),
            i(l, {
              class: r(["grow"]),
              variant: "outlined",
              onClick: o[5] || (o[5] = (t) => e.reset())
            }, {
              default: s(() => [
                n(a(e.resetLabel), 1)
              ]),
              _: 1
            })
          ], 2)
        ])
      ]),
      default: s(() => [
        p("div", c(e.$attrs, {
          ref: "root",
          class: e.rootStyles
        }), [
          f(e.$slots, "default")
        ], 16)
      ]),
      _: 3
    }, 8, ["is-open"])) : g("", !0)
  ]);
}
const ee = /* @__PURE__ */ H(I, [["render", Q]]);
export {
  ee as O
};
//# sourceMappingURL=OrFilterPopover-C8lXb-hJ.mjs.map
